const browserHostname = typeof window !== "undefined" ? window.location.hostname : "";
const browserProtocol = typeof window !== "undefined" ? window.location.protocol : "https:";
const isLocalBrowser = browserHostname === "localhost" || browserHostname === "127.0.0.1";

export const API_BASE_URL =
  !isLocalBrowser && browserHostname.endsWith("lyriclious.com")
    ? `${browserProtocol}//backend.lyriclious.com`
    : process.env.REACT_APP_WORKSPACE_API_URL ||
      process.env.REACT_APP_API_URL ||
      "http://localhost:4000";

export const WORKSPACE_HOST =
  process.env.REACT_APP_WORKSPACE_URL || "https://workspace.lyriclious.com";
